import { Component, type ReactNode } from "react";
import { phCaptureException } from "@/lib/posthog";

type State = { hasError: boolean };

export class PostHogErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    phCaptureException(error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
        <h1 className="text-2xl font-bold text-primary">Something Went Wrong</h1>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md bg-primary px-5 py-2.5 font-semibold text-primary-foreground"
        >
          Reload Page
        </button>
      </div>
    );
  }
}
